import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Radio, Zap } from "lucide-react";
import api from "../../lib/api";
import { toast } from "sonner";
import { useAuth } from "../../contexts/AuthContext";

/**
 * Header chip labeled "Connexion Trigo Express" — links to /driver/express
 * where the driver can go online/offline. Also shows their current state.
 */
export default function DriverOnlineToggle() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState({ express_enabled: !!user?.express_enabled, is_online: !!user?.is_online });

  useEffect(() => {
    let cancelled = false;
    api.get("/driver/express/dashboard").then(({ data }) => {
      if (!cancelled) setStatus({ express_enabled: !!data.express_enabled, is_online: !!data.is_online });
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [user?.id]);

  const { express_enabled, is_online } = status;

  const handleClick = () => {
    if (!express_enabled) {
      toast.error("Trigo Express n'est pas activé pour votre compte", {
        description: "Contactez l'administrateur pour être ajouté à la plateforme.",
      });
      return;
    }
    navigate("/driver/express");
  };

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border text-xs font-medium transition-all ${
        is_online
          ? "bg-emerald-500/15 text-emerald-100 border-emerald-400/40"
          : express_enabled
            ? "bg-[#F2A93B]/15 text-[#F2A93B] border-[#F2A93B]/40 hover:bg-[#F2A93B]/25"
            : "bg-white/5 text-white/50 border-white/20"
      }`}
      title={is_online ? "En ligne · voir le dashboard Trigo Express" : express_enabled ? "Ouvrir Trigo Express" : "Non activé — contactez l'admin"}
      data-testid="driver-online-toggle"
    >
      {is_online ? (
        <Radio className="w-3.5 h-3.5 animate-pulse" />
      ) : (
        <Zap className="w-3.5 h-3.5" />
      )}
      <span className="hidden sm:inline">
        {is_online ? "En ligne" : "Connexion Trigo Express"}
      </span>
    </button>
  );
}
